import api from "./api"
import { store } from "../app/store"

const getRequestOptions = () => {
  const storeValues = store.getState()
  const authToken = storeValues?.user?.user?.token
  return {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    },
  }
}

const requests = {
  checkEmail: (email) => {
    return api.get(`/v1/check/${email}`)
  },
  register: (data) => {
    return api.post("/v1/register", data)
  },
  login: (data) => {
    return api.post("/v1/login", data)
  },
  logout: () => {
    return api.post("/v1/logout", {}, getRequestOptions())
  },
  getSections: (page, limit) => {
    return api.get(`/v1/sections?page=${page}&limit=${limit}`, getRequestOptions())
  },
  getEpisode: (id) => {
    return api.get(`/v1/episodes/${id}`, getRequestOptions())
  },
  getSeries: (id) => {
    return api.get(`/v1/series/${id}`, getRequestOptions())
  },
  getPlans: () => {
    return api.get("/v1/plans")
  },
  createCheckoutSession: (data) => {
    return api.post("/v1/plans/checkout", data, getRequestOptions())
  },
  createPortalSession: (data) => {
    return api.post("/v1/plans/portal", data, getRequestOptions())
  },
  getUserSubscription: () => {
    return api.get("/v1/users/subscription", getRequestOptions())
  },
  getSubscriptionStatus: () => {
    return api.get("/v1/users/subscription/status", getRequestOptions())
  },
  getPaymentMethods: () => {
    return api.get("/v1/plans/payment-methods", getRequestOptions())
  },
  getBillingProfile: () => {
    return api.get("/v1/users/billing-profile", getRequestOptions())
  },
  // Response carries the Pix bearer QR: never log it.
  createPixCheckout: (data) => {
    return api.post("/v1/plans/pix/checkout", data, getRequestOptions())
  },
  cancelSubscription: () => {
    return api.post("/v1/users/subscription/cancel", {}, getRequestOptions())
  },
  reactivateSubscription: () => {
    return api.post("/v1/users/subscription/reactivate", {}, getRequestOptions())
  },
  // { to: "pix", price_id, address? } → { qr, payment_method } · { to: "card",
  // price_id, success_url, cancel_url } → { url }. QR and URL are bearer
  // secrets: never log them.
  switchSubscription: (data) => {
    return api.post("/v1/users/subscription/switch", data, getRequestOptions())
  },
  // { reauthorize: true } → QR that reauthorizes Pix Automático; otherwise
  // the QR of the open Pix charge. Never log the response.
  payPendingSubscription: (data = {}) => {
    return api.post("/v1/users/subscription/pay", data, getRequestOptions())
  },
  // { price_id } → status: the other plan from the next renewal (api D69).
  changePlan: (data) => {
    return api.post("/v1/users/subscription/plan", data, getRequestOptions())
  },
  cancelPlanChange: () => {
    return api.delete("/v1/users/subscription/plan", getRequestOptions())
  },
  // → [{ name, uf }]: cities for the billing address when the CEP is not
  // found (api D71).
  searchMunicipios: (query) => {
    return api.get("/v1/municipios", { ...getRequestOptions(), params: { q: query } })
  },
  setEpisodeWatched: (id, data) => {
    return api.put(`/v1/users/episodes/${id}/watched`, data, getRequestOptions())
  },
  createResetPassword: (data) => {
    return api.post("/v1/reset-password", data)
  },
  getResetPassword: (token) => {
    return api.get(`/v1/reset-password/${token}`)
  },
  resetPassword: (token, data) => {
    return api.put(`/v1/reset-password/${token}`, data)
  },
  updatePassword: (data) => {
    return api.put("/v1/update-password", data, getRequestOptions())
  },
  addToWaitlist: (data) => {
    return api.post("/v1/user-waitlist", data)
  },
  search: (page, limit, title) => {
    return api.get(`/v1/search?page=${page}&limit=${limit}&title=${title}`, getRequestOptions())
  },
  updateTaxID: (data) => {
    return api.patch("/v1/users/customer/tax-id", data, getRequestOptions())
  },
  getMonthlySchedule: () => {
    return api.get("/v1/cms/monthly-schedule", getRequestOptions())
  },
  markScheduleViewed: (data) => {
    return api.post("/v1/users/schedule/viewed", data, getRequestOptions())
  },
  getHomeBanners: () => {
    return api.get("/v1/home/banners", getRequestOptions())
  },
}

export default requests
